import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const disconnectXeroOrganization = (apiKey: string) => {
    return axiosPrivate.delete(`/dashboard/api/v1/xero/disconnect?api_key=${apiKey}`)
}